import { State } from 'src/replicant/State';
import { getVisiblePetState } from '../fate/fate.getters';
import {
  canSeeLeague,
  hasJoinedLeague,
} from '../match2/leagues/leagues.getters';
import {
  championsLeagueDuration,
  championsLeagueFirstStart,
} from './championsLeague.ruleset';
import { ChampionsLeagueUserProperties } from './championsLeague.analytics.schema';
import { duration } from '@play-co/components';
import { match2MaxLevelChangedAt } from '../match2/match2.ruleset';
import { AvatarFrameId } from '../profile/frames';

/**
 * Check if user should see the new masters league arena
 * @param state
 * @returns
 */
export function isArenaAvailable(state: State): boolean {
  return hasJoinedLeague(state);
}

/**
 * Check if user can see the new masters league arena
 * @param state
 * @returns
 */
export function canSeeArena(state: State, now: number): boolean {
  // Cannot see arena while pet is aslepp
  if (getVisiblePetState(state, now, false) === 'sleeping') {
    return false;
  }

  // Can only see area if can see leagues
  return canSeeLeague(state);
}

/**
 * Retrieve the remaining champions league time, based on last time max level has changed.
 * The total duration is 2 weeks after the change date.
 */
export function getChampionsLeagueRemainingTime(now: number): number {
  const endTime = match2MaxLevelChangedAt.getTime() + championsLeagueDuration;
  return Math.max(0, endTime - now);
}

/**
 * Get currently equipped champions league avatar frame.
 */
export function getChampionsLeagueAvatarFrame(
  state: State,
): AvatarFrameId | undefined {
  // If not joined league, return undefined
  if (!hasJoinedLeague(state)) return undefined;
  return 'league_crown';
}
